import { useState } from "react";
import { SiteData } from "../Data/SiteData";
import SelectDropdown from "../SelectDropdown";
import WebDesigner, { EditorMode } from "../WebDesigner";



export default function PageSelectMenu({designer,currentPage,siteData}:{designer:WebDesigner,currentPage:string,siteData:SiteData}){

    let options= GetLinearPageOptions(siteData);
    let [keyToggle,setKeyToggle] = useState(true);
    if(siteData.pages.length==0)
        return <></>

    if(designer.state.mode == EditorMode.Blogging){
     return <span style={{color:"#9A9A9A"}}>Editing Blog Post</span>
    }

    return (
        <div className="flex-row">
            <span style={{color:"#9A9A9A"}}>Page:</span>
            {options.length>0 &&
            <SelectDropdown allowFilter={true} key={keyToggle.toString()} options={options} defaultValue = {currentPage} expandToRight={true} onChange={(value:string)=>{
                designer.trySwitchPage(value,()=>{
                    setKeyToggle(!keyToggle);


                });
            }}/>}

        </div>
    )
}


export class PageOptionParams  {
    useURLinsteadOfId:boolean = false;
    combineWithComma:boolean = false;
    excludeDisabled:boolean = false;
    excludeHidden:boolean = false;
    duplicatedPagesOnly:boolean = false;
}



export function GetLinearPageOptions(siteData:SiteData,useURLinsteadOfId:boolean = false,combineWithComma:boolean = false,excludeDisabledAndHidden:boolean = false,duplicatedPagesOnly = false){

    let params = new PageOptionParams();
    params.useURLinsteadOfId = useURLinsteadOfId;
    params.combineWithComma = combineWithComma;
    params.excludeDisabled = excludeDisabledAndHidden;
    params.excludeHidden = excludeDisabledAndHidden;
    params.duplicatedPagesOnly = duplicatedPagesOnly;

    return GetLinearPageOptionsWithParams(siteData,params);

}


export function GetLinearPageOptionsWithParams(siteData:SiteData,params:PageOptionParams){

    let useURLinsteadOfId:boolean = params.useURLinsteadOfId??false;
    let combineWithComma:boolean = params.combineWithComma??false;
    let excludeDisabled:boolean = params.excludeDisabled??false;
    let excludeHidden:boolean = params.excludeHidden??false;
    let duplicatedPagesOnly:boolean = params.duplicatedPagesOnly??false;

    let options= [];

    for(let i = 0;i<siteData.pages.length;i++){

        let page = siteData.pages[i];

        if(page.isFolder &&page.children&&page.children.length>0){
            for(let e=  0;e<page.children.length;e++){

           

                    if(duplicatedPagesOnly&&!page.children[e].isDuplicateAllLocationPage)
                        continue;
                    if(excludeDisabled&&page.children[e].isDisabled)
                        continue;
                    if(excludeHidden&&page.children[e].isHidePage)
                        continue;

                    if(combineWithComma){
                        options.push({label:page.children[e].name,value: page.children[e].pageId+","+page.children[e].url});
                    }

                    else if(useURLinsteadOfId)
                        options.push({label:page.children[e].name,  value: page.children[e].url});
                    else
                        options.push({label:page.children[e].name,value: page.children[e].pageId});
                
            }
        }
        else if(!page.isFolder){

            if(duplicatedPagesOnly&&!page.isDuplicateAllLocationPage)
                continue;
            if(excludeDisabled&&page.isDisabled)
                continue;
            if(excludeHidden&&page.isHidePage)
                continue;

            if(useURLinsteadOfId)
                options.push({label:page.name,value:page.url});
            else
            options.push({label:page.name,value:page.pageId});
        }
    }

        if(useURLinsteadOfId)
    options.sort((a,b)=>{ return a.value.localeCompare(b.value)});
        else
    options.sort((a,b)=>{ return (a.label as string).localeCompare(b.label as string)});


    return options;
}


export function GetLinearPageData (siteData:SiteData){

    let pages = [];


    for(let i = 0;i<siteData.pages.length;i++){
        pages.push(siteData.pages[i]);
        if(siteData.pages[i].children){
            let children = siteData.pages[i].children??[];
            for(let e = 0;e<children.length;e++){

                pages.push(children[e]);
            }
        }
    }

    return pages;
}
